import '../../js/common.js';
import '../../js/idp.js';
import '../../js/password-recovery.js';
import '../../js/reset-input.js';
import '../../js/totp.js';
import '../../js/language-switcher.js';
import '../../js/password-policy.js';
